export default {"src":"/_next/static/media/call.fe730418.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};